import { defineMessages } from 'react-intl';
import { CAMPAIGN_LEVEL, CAMPAIGN_TYPE } from './Campaigns.helpers';

export default {
  modals: defineMessages({
    endNowTitle: {
      id: 'campaigns.modals.end-now-title',
      defaultMessage: 'Are you sure you want to end this campaign?',
    },
    endNowDescription: {
      id: 'campaigns.modals.end-now-description',
      defaultMessage: 'Ending this campaign will prevent new bookings from receiving the campaign discount.',
    },
    endNowDisclaimer: {
      id: 'campaigns.modals.end-now-disclaimer',
      defaultMessage:
        'Bookings already made with this discount will retain their discounted rate, even if they take place after the campaign end date.',
    },
  }),
  form: defineMessages({
    titleAdd: {
      id: 'campaigns.form.title.add',
      defaultMessage: 'Create campaign',
    },
    titleEdit: {
      id: 'campaigns.form.title.edit',
      defaultMessage: 'Edit campaign',
    },
    titleView: {
      id: 'campaigns.form.title.view',
      defaultMessage: 'View campaign',
    },
    titleCampaignType: {
      id: 'campaigns.form.title.campaign-type',
      defaultMessage: 'Campaign type',
    },
    titleCampaignDetails: {
      id: 'campaigns.form.title.campaign-details',
      defaultMessage: 'Campaign details',
    },
    titleTimeSlots: {
      id: 'campaigns.form.title.time-slots',
      defaultMessage: 'Campaign schedule',
    },
    subTitleTimeSlots: {
      id: 'campaigns.form.sub-title.time-slots',
      defaultMessage: 'Schedule',
    },
    descriptionTimeSlots: {
      id: 'campaigns.form.description.time-slots',
      defaultMessage: 'Choose when you want this campaign to run during the week. Add multiple time slots if needed.',
    },
    empty: {
      id: 'campaigns.form.empty',
      defaultMessage: 'No campaigns can be created at this time.',
    },
    labelCampaign: {
      id: 'campaigns.form.label.campaign',
      defaultMessage: 'Select campaign',
    },
    labelCampaignName: {
      id: 'campaigns.form.label.campaign-name',
      defaultMessage: 'Campaign name',
    },
    labelCampaignNameOptional: {
      id: 'campaigns.form.label.campaign-name-optional',
      defaultMessage: 'Campaign name (optional)',
    },
    labelDiscountAmount: {
      id: 'campaigns.form.label.discount-amount',
      defaultMessage: 'Discount amount',
    },
    labelGrow: {
      id: 'campaigns.form.label.grow',
      defaultMessage: 'How would you like to grow your business?',
    },
    labelServices: {
      id: 'campaigns.form.label.services',
      defaultMessage: 'Services',
    },
    labelStartDate: {
      id: 'campaigns.form.label.start-date',
      defaultMessage: 'Start date',
    },
    labelEndDate: {
      id: 'campaigns.form.label.end-date',
      defaultMessage: 'End date',
    },
    labelSetEndDate: {
      id: 'campaigns.form.label.set-end-date',
      defaultMessage: 'Set end date',
    },
    optionNoEndDate: {
      id: 'campaigns.form.option.no-end-date',
      defaultMessage: 'None',
    },
    labelAllServices: {
      id: 'campaigns.form.label.all-services',
      defaultMessage: 'All Services',
    },
    labelAllClasses: {
      id: 'campaigns.form.label.all-classes',
      defaultMessage: 'All Classes',
    },
    labelSomeServices: {
      id: 'campaigns.form.label.some-services',
      defaultMessage: '{selected}/{total} selected',
    },
    labelSelectedServices: {
      id: 'campaigns.form.label.selected-services',
      defaultMessage: 'Selected services',
    },
    labelSelectedClasses: {
      id: 'campaigns.form.label.selected-classes',
      defaultMessage: 'Selected classes',
    },
    newLabel: {
      id: 'campaigns.form.label.new',
      defaultMessage: 'New!',
    },
    optionPercentage: {
      id: 'campaigns.form.label.option-percentage',
      defaultMessage: '{value}%',
    },
    placeholderCampaignName: {
      id: 'campaigns.form.placeholder.campaign-name',
      defaultMessage: 'e.g. Christmas sale',
    },
    placeholderDiscountAmount: {
      id: 'campaigns.form.placeholder.discount-amount',
      defaultMessage: 'Select amount',
    },
    placeholderEndDate: {
      id: 'campaigns.form.placeholder.end-date',
      defaultMessage: 'No end date',
    },
    btnAdd: {
      id: 'campaigns.form.button.launch-campaign',
      defaultMessage: 'Launch campaign',
    },
    btnEdit: {
      id: 'campaigns.form.button.edit',
      defaultMessage: 'Save',
    },
    btnEndCampaign: {
      id: 'campaigns.form.button.end-campaign',
      defaultMessage: 'End campaign',
    },
    btnCampaigns: {
      id: 'campaigns.form.button.campaigns',
      defaultMessage: 'Campaigns',
    },
    btnCancel: {
      id: 'campaigns.form.button.cancel',
      defaultMessage: 'Cancel',
    },
    btnEndNow: {
      id: 'campaigns.form.button.end-now',
      defaultMessage: 'End now',
    },
    btnDuplicate: {
      id: 'campaigns.form.button.duplicate',
      defaultMessage: 'Duplicate campaign',
    },
    errorStartDate: {
      id: 'campaigns.form.error.start-date-before-today',
      defaultMessage: 'Start date must not be in the past',
    },
    errorEndBeforeStart: {
      id: 'campaigns.form.error.end-date-before-start',
      defaultMessage: 'End date must be after start date',
    },
    errorEndBeforeToday: {
      id: 'campaigns.form.error.end-date-before-today',
      defaultMessage: 'End date must not be in the past',
    },
    errorNoDiscountSelected: {
      id: 'campaigns.form.error.no-discount',
      defaultMessage: 'A discount option must be selected',
    },
    errorNoServicesSelected: {
      id: 'campaigns.form.error.no-services',
      defaultMessage: 'At least 1 service needs to be chosen',
    },
    daySunday: {
      id: 'campaigns.form.day.sunday',
      defaultMessage: 'Sun',
    },
    daySundayFull: {
      id: 'campaigns.form.day.sunday-full',
      defaultMessage: 'Sunday',
    },
    dayMonday: {
      id: 'campaigns.form.day.monday',
      defaultMessage: 'Mon',
    },
    dayMondayFull: {
      id: 'campaigns.form.day.monday-full',
      defaultMessage: 'Monday',
    },
    dayTuesday: {
      id: 'campaigns.form.day.tuesday',
      defaultMessage: 'Tue',
    },
    dayTuesdayFull: {
      id: 'campaigns.form.day.tuesday-full',
      defaultMessage: 'Tuesday',
    },
    dayWednesday: {
      id: 'campaigns.form.day.wednesday',
      defaultMessage: 'Wed',
    },
    dayWednesdayFull: {
      id: 'campaigns.form.day.wednesday-full',
      defaultMessage: 'Wednesday',
    },
    dayThursday: {
      id: 'campaigns.form.day.thursday',
      defaultMessage: 'Thu',
    },
    dayThursdayFull: {
      id: 'campaigns.form.day.thursday-full',
      defaultMessage: 'Thursday',
    },
    dayFriday: {
      id: 'campaigns.form.day.friday',
      defaultMessage: 'Fri',
    },
    dayFridayFull: {
      id: 'campaigns.form.day.friday-full',
      defaultMessage: 'Friday',
    },
    daySaturday: {
      id: 'campaigns.form.day.saturday',
      defaultMessage: 'Sat',
    },
    daySaturdayFull: {
      id: 'campaigns.form.day.saturday-full',
      defaultMessage: 'Saturday',
    },
    labelStartTime: {
      id: 'campaigns.form.label.start-time',
      defaultMessage: 'Start time',
    },
    labelEndTime: {
      id: 'campaigns.form.label.end-time',
      defaultMessage: 'End time',
    },
    inlineLabelStartTime: {
      id: 'campaigns.form.inline-label.start-time',
      defaultMessage: 'Start',
    },
    inlineLabelEndTime: {
      id: 'campaigns.form.inline-label.end-time',
      defaultMessage: 'End',
    },
    scheduleTimeSeparator: {
      id: 'campaigns.form.schedule-time-separator',
      defaultMessage: 'to',
    },
    errorStartTimeAfterEndTime: {
      id: 'campaigns.form.error.start-time-after-end-time',
      defaultMessage: 'Start time must be before end time',
    },
    errorNoDaySelected: {
      id: 'campaigns.form.error.no-day-selected',
      defaultMessage: 'Choose at least one day for your campaign to run',
    },
    errorOverlappingTimeSlots: {
      id: 'campaigns.form.error.overlapping-time-slots',
      defaultMessage: 'Scheduled hours cannot overlap',
    },
  }),
  saga: defineMessages({
    createSuccess: {
      id: 'campaigns.saga.create-success',
      defaultMessage: 'Campaign created successfully!',
    },
    loadError: {
      id: 'campaigns.saga.load-error',
      defaultMessage: "We couldn't load that campaign. Please try again later.",
    },
    duplicateError: {
      id: 'campaigns.saga.duplicate-error',
      defaultMessage: "We couldn't duplicate that campaign. Please try again.",
    },
    duplicateUnavailableError: {
      id: 'campaigns.saga.duplicate-unavailable-error',
      defaultMessage: 'You already have an active campaign of this type. End it before creating a new one.',
    },
    createError: {
      id: 'campaigns.saga.create-error',
      defaultMessage: 'An error occurred while creating the campaign. Please try again later.',
    },
    overlapError: {
      id: 'campaigns.saga.overlap-error',
      defaultMessage: 'This campaign overlaps with an existing one. Change the days, times, or services and try again.',
    },
    legacyOverlapError: {
      id: 'campaigns.saga.legacy-overlap-error',
      defaultMessage:
        'This campaign overlaps with an existing campaign. Please update the start or end dates and try again.',
    },
    updateSuccess: {
      id: 'campaigns.saga.update-success',
      defaultMessage: 'Campaign pack updated successfully!',
    },
    updateError: {
      id: 'campaigns.saga.update-error',
      defaultMessage: 'An error occurred while updating the campaign. Please try again later.',
    },
    endSuccess: {
      id: 'campaigns.saga.end-success',
      defaultMessage: 'Campaign has been successfully ended',
    },
  }),
  table: defineMessages({
    headerCampaigns: {
      id: 'campaigns.table.header.campaigns',
      defaultMessage: 'Campaign',
    },
    headerAmount: {
      id: 'campaigns.table.amount',
      defaultMessage: 'Amount',
    },
    headerStartDate: {
      id: 'campaigns.table.header.start-date',
      defaultMessage: 'Start date',
    },
    tooltipStartDate: {
      id: 'campaigns.table.tooltip.start-date',
      defaultMessage:
        '<p>Time-based campaigns go live as soon as you create them, but only apply to schedules from your chosen start date onward.</p><p>All other campaigns apply based on the booking date of eligible reservations.</p>',
    },
    headerEndDate: {
      id: 'campaigns.table.header.end-date',
      defaultMessage: 'End date',
    },
    tooltipEndDate: {
      id: 'campaigns.table.tooltip.end-date',
      defaultMessage:
        'Discounts will apply to any eligible bookings made within the selected date range, even if the experience occurs later.',
    },
    endDate: {
      id: 'campaigns.table.end-date-value',
      defaultMessage: '{endDateTime, select, null {No end date} other {{endDateTime, date, medium}}}',
    },
    headerServices: {
      id: 'campaigns.table.services',
      defaultMessage: 'Services',
    },
    headerClasses: {
      id: 'campaigns.table.classes',
      defaultMessage: 'Classes',
    },
    headerItems: {
      id: 'campaigns.table.items',
      defaultMessage: 'Items',
    },
    headerRedemptions: {
      id: 'campaigns.table.header.redemptions',
      defaultMessage: 'Redemptions',
    },
    headerRevenue: {
      id: 'campaigns.table.header.revenue',
      defaultMessage: 'Revenue',
    },
    servicesAll: {
      id: 'campaigns.table.services-all',
      defaultMessage: 'All',
    },
    notApplicable: {
      id: 'campaigns.table.not-applicable',
      defaultMessage: 'N/A',
    },
    tooltipRedemptions: {
      id: 'campaigns.table.tooltip.redemptions',
      defaultMessage: '<strong>Note:</strong> Redemptions and earnings data updates weekly.',
    },
    tooltipEarnings: {
      id: 'campaigns.table.tooltip.earnings',
      defaultMessage: 'If applicable, inclusive of VAT/GST',
    },
    updatedMessage: {
      id: 'campaigns.table.updated-message',
      defaultMessage: '{dateTime, date, medium} by {name}',
    },
    servicesSelected: {
      id: 'campaigns.table.services-selected',
      defaultMessage: '{count} services selected',
    },
    classesSelected: {
      id: 'campaigns.table.classes-selected',
      defaultMessage: '+{count} classes selected',
    },
    itemsSelected: {
      id: 'campaigns.table.items-selected',
      defaultMessage: '+{count} items selected',
    },
  }),

  nameOverrides: defineMessages({
    [CAMPAIGN_TYPE.ALL_USER]: {
      id: 'campaigns.type.name.override.all-user',
      defaultMessage: 'Grow your business fast',
    },
    [CAMPAIGN_TYPE.NEW_USER]: {
      id: 'campaigns.type.name.override.new-user',
      defaultMessage: 'Get new members',
    },
    [CAMPAIGN_TYPE.TIME_SLOT_ALL_USER]: {
      id: 'campaigns.type.name.override.time-slot-all-user',
      defaultMessage: 'Fill specific time slots',
    },
    [CAMPAIGN_TYPE.WINBACK]: {
      id: 'campaigns.type.name.override.winback',
      defaultMessage: 'Reactivate past members',
    },
  }),

  fnbNameOverrides: defineMessages({
    [CAMPAIGN_TYPE.ALL_USER]: {
      id: 'campaigns.type.name.fnb-override.all-user',
      defaultMessage: 'Grow your business fast',
    },
    [CAMPAIGN_TYPE.NEW_USER]: {
      id: 'campaigns.type.name.fnb-override.new-user',
      defaultMessage: 'Get new customers',
    },
    [CAMPAIGN_TYPE.TIME_SLOT_ALL_USER]: {
      id: 'campaigns.type.name.fnb-override.time-slot-all-user',
      defaultMessage: 'Fill specific time slots',
    },
    [CAMPAIGN_TYPE.WINBACK]: {
      id: 'campaigns.type.name.fnb-override.winback',
      defaultMessage: 'Reactivate past customers',
    },
  }),

  levelOverrides: defineMessages({
    [CAMPAIGN_LEVEL.VENUE]: {
      id: 'campaigns.level.name.override.venue',
      defaultMessage: 'Venue',
    },
    [CAMPAIGN_LEVEL.CLASS]: {
      id: 'campaigns.level.name.override.class',
      defaultMessage: 'Service',
    },
  }),

  descriptionOverrides: defineMessages({
    [CAMPAIGN_TYPE.ALL_USER]: {
      id: 'campaigns.type.description.override.all-user',
      defaultMessage:
        "Boost visibility, drive more bookings, and accelerate growth when you're ready to scale your business.",
    },
    [CAMPAIGN_TYPE.NEW_USER]: {
      id: 'campaigns.type.description.override.new-user',
      defaultMessage:
        "Expand your reach to fresh audiences and attract people who haven't discovered your business yet.",
    },
    [CAMPAIGN_TYPE.TIME_SLOT_ALL_USER]: {
      id: 'campaigns.type.description.override.time-slot-all-user',
      defaultMessage:
        'Turn slower hours into booking opportunities by promoting availability during specific days and times.',
    },
    [CAMPAIGN_TYPE.WINBACK]: {
      id: 'campaigns.type.description.override.winback',
      defaultMessage:
        'Bring familiar faces back through the door and help former members rebuild their routine with your business.',
    },
  }),

  appliesTo: defineMessages({
    [CAMPAIGN_TYPE.ALL_USER]: {
      id: 'campaigns.type.applies-to.all-user',
      defaultMessage: 'Applies to: All members',
    },
    [CAMPAIGN_TYPE.NEW_USER]: {
      id: 'campaigns.type.applies-to.new-user',
      defaultMessage: 'Applies to: Members who have never visited your business',
    },
    [CAMPAIGN_TYPE.TIME_SLOT_ALL_USER]: {
      id: 'campaigns.type.applies-to.time-slot-all-user',
      defaultMessage: 'Applies to: All members',
    },
    [CAMPAIGN_TYPE.WINBACK]: {
      id: 'campaigns.type.applies-to.winback',
      defaultMessage: 'Applies to: Members who have not visited your business in at least 3 months',
    },
  }),

  campaignLimit: defineMessages({
    [CAMPAIGN_TYPE.ALL_USER]: {
      id: 'campaigns.type.campaign-limit.all-user',
      defaultMessage: 'Only one active campaign per class/service',
    },
    [CAMPAIGN_TYPE.NEW_USER]: {
      id: 'campaigns.type.campaign-limit.new-user',
      defaultMessage: 'Only one active campaign per class/service',
    },
    [CAMPAIGN_TYPE.TIME_SLOT_ALL_USER]: {
      id: 'campaigns.type.campaign-limit.time-slot-all-user',
      defaultMessage: 'Campaign limit: No limit',
    },
    [CAMPAIGN_TYPE.WINBACK]: {
      id: 'campaigns.type.campaign-limit.winback',
      defaultMessage: 'Only one active campaign per class/service',
    },
  }),
};
